import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// REGISTER SERVICE WORKER
if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      const existing = await navigator.serviceWorker.getRegistration("/");
      if (existing) {
        console.log("Existing SW found:", existing);
      }

      const reg = await navigator.serviceWorker.register("/sw.js", {
        scope: "/",
      });

      console.log("Service Worker registered:", reg);
    } catch (err) {
      console.error("Service Worker registration failed:", err);
    }
  });
}